import { ShoppingCartService } from './../services/shoppingCart.service';
import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { catchError, forkJoin, map, of } from 'rxjs';
import { Address } from '../models/address.model';
import { AmmShoppingCartBackEnd } from '../models/catalog.model';
import { CommonStore } from '../stores'

export interface CheckoutResolvedData {
    currentAddress: Address | undefined | null;
    isShippingAddressFormValid: boolean;
    // null 表示购物车没取到，结账页会进入 "Checkout unavailable" 状态
    cart: AmmShoppingCartBackEnd | null;
}

@Injectable({providedIn: 'root'})
export class ShippingAddressResolver implements Resolve<CheckoutResolvedData> {
    private commonStore = inject(CommonStore);
    constructor(private shopingcartService: ShoppingCartService ) {

    }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // 三个请求互不依赖，并行发出，结账页只等一次往返。
        // 购物车取失败不拦导航，交给结账页显示错误。
        return forkJoin({
            addresses: this.shopingcartService.getAllAddress(),
            buyer: this.shopingcartService.getBuyerInfo(),
            cart: this.shopingcartService.getShoppingCart().pipe(
                map((response) => response?.dataList?.[0] ?? null),
                catchError(() => of(null))
            ),
        }).pipe(map(({ addresses, buyer, cart }): CheckoutResolvedData => {
            const addressList = addresses.dataList ?? [];
            // Address rendering and operations depend on both values. Publish the
            // matching snapshot before the route activates so they cannot be mixed
            // with buyer state left in the singleton store from an earlier session.
            this.commonStore.setAddressContext(addressList, buyer);

            const currentSelectedShippingAddress: Address | undefined | null =  buyer.defaultDeliveryAddress ? buyer.defaultDeliveryAddress : addressList && addressList.length > 0 ? addressList[0]: null;
            const isShippingAddressFormValid: boolean = (addressList?.length??0) > 0
            return {
                currentAddress: currentSelectedShippingAddress,
                isShippingAddressFormValid: isShippingAddressFormValid,
                cart: cart,
            };
        }));
    }

}
